import { render, staticRenderFns } from "./DestinationGroup.vue?vue&type=template&id=2288485e"
import script from "./DestinationGroup.vue?vue&type=script&lang=ts"
export * from "./DestinationGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports